(function(){"use strict";class FelinePainScaleCalculator extends HTMLElement{connectedCallback(){if(this.__fpsInit)return;this.__fpsInit=true;var root=this;
const SCALE = [
  {
    score:0, band:"No pain", color:"var(--fps-s0)", tension:"Body tension: minimal",
    psych:[
      "Content and quiet when unattended",
      "Comfortable when resting",
      "Interested in or curious about surroundings"
    ],
    palp:["Not bothered by palpation of wound or surgery site, or to palpation elsewhere"],
    result:"Comfortable. No intervention indicated for pain. Continue routine monitoring and rescore per protocol.",
    reassess:false
  },
  {
    score:1, band:"Possibly / mildly painful", color:"var(--fps-s1)", tension:"Body tension: mild",
    psych:[
      "Signs are often subtle and not easily detected in the hospital setting; more likely to be detected by the owner at home",
      "Earliest signs at home may be withdrawal from surroundings or change in normal routine",
      "In the hospital, may be content or slightly unsettled",
      "Less interested in surroundings but will look around to see what is going on"
    ],
    palp:["May or may not react to palpation of wound or surgery site"],
    result:"Possible mild pain. Observe closely, rescore frequently, and consider analgesia if signs persist or progress.",
    reassess:false
  },
  {
    score:2, band:"Mild pain", color:"var(--fps-s2)", tension:"Body tension: mild to moderate",
    psych:[
      "Decreased responsiveness, seeks solitude",
      "Quiet, loss of brightness in eyes",
      "Lays curled up or sits tucked up (all four feet under body, shoulders hunched, head held slightly lower than shoulders, tail curled tightly around body) with eyes partially or mostly closed",
      "Hair coat appears rough or fluffed up",
      "May intensively groom an area that is painful or irritating",
      "Decreased appetite, not interested in food"
    ],
    palp:[
      "Responds aggressively or tries to escape if painful area is palpated or approached",
      "Tolerates attention, may even perk up when petted as long as painful area is avoided"
    ],
    result:"Mild pain present. Provide / adjust analgesia and reassess the analgesic plan.",
    reassess:true
  },
  {
    score:3, band:"Mild to moderate pain", color:"var(--fps-s3)", tension:"Body tension: moderate",
    psych:[
      "Constantly yowling, growling, or hissing when unattended",
      "May bite or chew at wound, but unlikely to move if left alone"
    ],
    palp:[
      "Growls or hisses at non-painful palpation (may be experiencing hyperalgesia, wind-up, or fearful that pain could be made worse)",
      "Reacts aggressively to palpation, adamantly pulls away / guards the painful area"
    ],
    result:"Moderate pain. Escalate analgesia now and reassess the analgesic plan. Consider multimodal therapy.",
    reassess:true
  },
  {
    score:4, band:"Moderate to severe pain", color:"var(--fps-s4)", tension:"Body tension: moderate to severe (may be rigid)",
    psych:[
      "Prostrate",
      "Potentially unresponsive to or unaware of surroundings, difficult to distract from pain",
      "Receptive to care (even mean or wild cats will be more tolerant of contact)"
    ],
    palp:[
      "May not respond to palpation",
      "May be rigid to avoid painful movement"
    ],
    result:"Severe pain. Urgent, aggressive multimodal analgesia required. Reassess the analgesic plan immediately and monitor continuously.",
    reassess:true
  }
];

let selected = null;

function buildCards(){
  const grid = root.querySelector("#"+'grid');
  SCALE.forEach(s=>{
    const card = document.createElement('div');
    card.className='card';
    card.style.setProperty('--barcolor', s.color);
    card.setAttribute('role','button');
    card.setAttribute('tabindex','0');
    card.dataset.score = s.score;

    const psychLis = s.psych.map(t=>`<li>${t}</li>`).join('');
    const palpLis = s.palp.map(t=>`<li>${t}</li>`).join('');
    const flag = s.reassess ? `<span class="flag">&#9873; Reassess analgesic plan</span>` : '';

    card.innerHTML = `
      <div class="card-head">
        <div class="score-chip">${s.score}</div>
        <div>
          <div class="score-title">Pain score ${s.score}</div>
          <div class="score-band">${s.band}</div>
        </div>
        <span class="tension">${s.tension}</span>
      </div>
      <div class="domains">
        <div class="domain">
          <h4>Psychological &amp; behavioural</h4>
          <ul>${psychLis}</ul>
        </div>
        <div class="domain">
          <h4>Response to palpation</h4>
          <ul>${palpLis}</ul>
        </div>
      </div>
      ${flag}
    `;
    card.addEventListener('click',()=>selectScore(s.score));
    card.addEventListener('keydown',(e)=>{ if(e.key==='Enter'||e.key===' '){e.preventDefault();selectScore(s.score);} });
    grid.appendChild(card);
  });
}

function selectScore(score){
  selected = score;
  const s = SCALE[score];
  root.querySelectorAll('.card').forEach(c=>{
    c.classList.toggle('selected', Number(c.dataset.score)===score);
  });
  root.querySelector("#"+'result-bar').style.background = s.color;
  const num = root.querySelector("#"+'result-num');
  num.textContent = score;
  num.style.background = s.color;
  num.style.color = '#06121a';
  root.querySelector("#"+'result-title').textContent = `Pain score ${score} — ${s.band}`;
  let desc = s.result;
  if(s.reassess){ desc += '  ⚑ This score triggers reassessment of the analgesic plan.'; }
  root.querySelector("#"+'result-desc').textContent = desc;
  root.querySelector("#"+'result').scrollIntoView({behavior:'smooth',block:'nearest'});
}

function resetTool(){
  selected = null;
  root.querySelectorAll('.card').forEach(c=>c.classList.remove('selected'));
  root.querySelector("#"+'result-bar').style.background = 'var(--fps-line)';
  const num = root.querySelector("#"+'result-num');
  num.textContent = '–'; num.style.background='var(--fps-line)'; num.style.color='var(--fps-muted)';
  root.querySelector("#"+'result-title').textContent = 'No score selected';
  root.querySelector("#"+'result-desc').textContent = 'Select the row above that best describes the patient to generate a pain score and analgesic guidance.';
  root.scrollIntoView({behavior:'smooth',block:'start'});
}

buildCards();

/* =================== SCALE TOGGLE =================== */
function switchScale(which){
  root.querySelector("#"+'csu-view').hidden     = which!=='csu';
  root.querySelector("#"+'fgs-view').hidden     = which!=='fgs';
  root.querySelector("#"+'unesp-view').hidden   = which!=='unesp';
  root.querySelector("#"+'glasgow-view').hidden = which!=='glasgow';
  root.querySelector("#"+'tab-csu').classList.toggle('active', which==='csu');
  root.querySelector("#"+'tab-fgs').classList.toggle('active', which==='fgs');
  root.querySelector("#"+'tab-unesp').classList.toggle('active', which==='unesp');
  root.querySelector("#"+'tab-glasgow').classList.toggle('active', which==='glasgow');
}

/* =================== FELINE GRIMACE SCALE =================== */
const FGS = [
  {key:'ears', name:'Ear position', opts:[
    'Ears facing forward',
    'Ears slightly pulled apart',
    'Ears flattened and rotated outwards'
  ]},
  {key:'orbital', name:'Orbital tightening', opts:[
    'Eyes opened',
    'Eyes partially opened',
    'Eyes squinted (eyelids closed or half closed)'
  ]},
  {key:'muzzle', name:'Muzzle tension', opts:[
    'Muzzle relaxed (round shape)',
    'Mild muzzle tension',
    'Muzzle tense (elliptical shape)'
  ]},
  {key:'whiskers', name:'Whisker position', opts:[
    'Whiskers loose and curved',
    'Whiskers slightly curved or straight',
    'Whiskers straight and moving forward (rostrally)'
  ]},
  {key:'head', name:'Head position', opts:[
    'Head above the shoulder line',
    'Head aligned with the shoulder line',
    'Head below the shoulder line or tilted down (chin toward chest)'
  ]}
];

const fgsState = {}; // key -> 0|1|2  (absent = not scored, 'na' handled by absence)

function buildFGS(){
  const grid = root.querySelector("#"+'fgs-grid');
  FGS.forEach((au,i)=>{
    const wrap = document.createElement('div');
    wrap.className='au';
    wrap.dataset.key = au.key;
    const opts = au.opts.map((t,v)=>
      `<button class="opt" data-key="${au.key}" data-val="${v}">
         <span class="opt-num">${v}</span>${t}
       </button>`).join('');
    wrap.innerHTML = `
      <div class="au-head">
        <span class="au-name">${i+1}. ${au.name}</span>
        <span class="au-val" id="val-${au.key}"></span>
      </div>
      <div class="au-opts">
        ${opts}
        <button class="opt na" data-key="${au.key}" data-val="na">N/A</button>
      </div>`;
    grid.appendChild(wrap);
  });
  grid.querySelectorAll('.opt').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const key = btn.dataset.key;
      const val = btn.dataset.val;
      if(val==='na'){ fgsState[key]='na'; }
      else { fgsState[key]=Number(val); }
      // update selected styling within this AU (scope to FGS grid)
      root.querySelectorAll(`#fgs-grid .opt[data-key="${key}"]`).forEach(o=>o.classList.remove('sel'));
      btn.classList.add('sel');
      const label = val==='na' ? 'N/A' : val;
      root.querySelector("#"+'val-'+key).textContent = 'Score: '+label;
      calcFGS();
    });
  });
}

function calcFGS(){
  let sum=0, scored=0;
  FGS.forEach(au=>{
    const v = fgsState[au.key];
    if(v!==undefined && v!=='na'){ sum+=v; scored++; }
  });
  const bar = root.querySelector("#"+'fgs-bar');
  const num = root.querySelector("#"+'fgs-num');
  const title = root.querySelector("#"+'fgs-title');
  const desc = root.querySelector("#"+'fgs-desc');
  const possible = scored*2;

  if(scored===0){
    bar.style.background='var(--fps-line)';
    num.textContent='–'; num.style.background='var(--fps-line)'; num.style.color='var(--fps-muted)';
    title.textContent='No action units scored';
    desc.textContent='Score each action unit above. The total and analgesia recommendation update automatically.';
    return;
  }

  const ratio = sum/possible;               // validated normalised score
  const outOf10 = Math.round(ratio*10*10)/10; // ratio expressed as /10
  const meets = ratio >= 0.39;
  const color = meets ? 'var(--fps-s4)' : 'var(--fps-s0)';

  bar.style.background=color;
  num.style.background=color; num.style.color='#06121a';
  num.textContent = (scored===5) ? sum : outOf10;

  const displayScore = (scored===5)
      ? `${sum}/10`
      : `${sum}/${possible} (${scored} of 5 units) = ${outOf10}/10 equivalent`;

  title.textContent = `FGS ${displayScore} — ratio ${ratio.toFixed(2)}`;

  if(meets){
    desc.textContent = `At or above the analgesia threshold (≥4/10, ratio ≥0.39). Analgesia is recommended, taking the patient's physical status and current medications into account. Re-score after intervention.`;
  } else {
    desc.textContent = `Below the analgesia threshold (≥4/10, ratio ≥0.39). Continue monitoring and re-score, especially after any procedure or change in condition.`;
  }
}

function resetFGS(){
  for(const k in fgsState) delete fgsState[k];
  root.querySelectorAll('#fgs-grid .opt').forEach(o=>o.classList.remove('sel'));
  root.querySelectorAll('#fgs-grid .au-val').forEach(v=>v.textContent='');
  calcFGS();
  root.scrollIntoView({behavior:'smooth',block:'start'});
}

buildFGS();

/* =================== UNESP-BOTUCATU MCPS (long form, 0-30) =================== */
const UNESP = [
  {
    sub:'Pain expression', max:12,
    items:[
      {key:'misc', name:'Miscellaneous behaviours',
       help:'Look for: <b>lying quiet but flicking the tail</b>; <b>contracting/extending the pelvic limbs and/or contracting the abdominal muscles (flank)</b>; <b>eyes half-closed</b>; <b>licking or biting the affected area</b>. Score by how many are present.',
       opts:['None of these behaviours','One of these behaviours','Two of these behaviours','Three or all of these behaviours']},
      {key:'wound', name:'Reaction to palpation of the surgical wound / affected area',
       opts:['Does not react when the area is touched or pressed',
             'Does not react when touched, but reacts when pressed',
             'Reacts when the area is touched and when pressed',
             'Reacts when the observer approaches the affected area']},
      {key:'abdomen', name:'Reaction to palpation of the abdomen / flank',
       opts:['Does not react when the abdomen/flank is touched or pressed',
             'Does not react when touched, but reacts when pressed',
             'Reacts when the abdomen/flank is touched and when pressed',
             'Reacts when the observer approaches the abdomen/flank']},
      {key:'vocal', name:'Vocalisation',
       opts:['Quiet, purrs when stimulated, or miaows / interacts',
             'Purrs spontaneously',
             'Growls, howls or hisses when handled',
             'Growls, howls or hisses spontaneously']}
    ]
  },
  {
    sub:'Psychomotor change', max:12,
    items:[
      {key:'posture', name:'Posture',
       opts:['Natural posture, relaxed muscles (moves normally)',
             'Natural posture but tense (moves little / reluctant to move)',
             'Sitting or sternal recumbency, back arched and head down',
             'Frequently alters body position seeking a comfortable posture']},
      {key:'comfort', name:'Comfort',
       opts:['Comfortable, awake or asleep, interacts when stimulated',
             'Quiet, slightly receptive when stimulated',
             'Quiet and "dissociated" from the environment',
             'Uncomfortable, restless (frequently changes body position)']},
      {key:'activity', name:'Activity',
       opts:['Moves normally (moves immediately when the cage is opened)',
             'Moves more than normal',
             'Quieter than normal (may hesitate to leave the cage)',
             'Reluctant to move']},
      {key:'attitude', name:'Attitude (mental state)',
       help:'Baseline is <b>satisfied</b>. Otherwise score by how many of these are present: <b>uninterested, indifferent, anxious, aggressive</b>.',
       opts:['Satisfied','One of the states','Two of the states','Three or all of the states']}
    ]
  },
  {
    sub:'Physiological variables', max:6,
    items:[
      {key:'abp', name:'Arterial blood pressure (vs pre-surgery baseline)',
       help:'Requires a pre-surgery baseline. If not measured, leave unscored — it is excluded from the total and flagged.',
       opts:['0–15% above pre-surgery value',
             '16–29% above pre-surgery value',
             '30–45% above pre-surgery value',
             '>45% above pre-surgery value']},
      {key:'appetite', name:'Appetite',
       opts:['Eating normally',
             'Eating more than normal',
             'Eating less than normal',
             'Not interested in food / no appetite']}
    ]
  }
];

const unespState = {}; // key -> 0..3

function buildUNESP(){
  const grid = root.querySelector("#"+'unesp-grid');
  UNESP.forEach((block,bi)=>{
    const head = document.createElement('div');
    head.className='subhead';
    head.innerHTML = `<h3>${bi+1}. ${block.sub}</h3><span class="line"></span>
      <span class="subtotal" id="sub-${bi}">0 / ${block.max}</span>`;
    grid.appendChild(head);

    block.items.forEach(item=>{
      const wrap = document.createElement('div');
      wrap.className='au';
      const help = item.help ? `<div class="au-help">${item.help}</div>` : '';
      const opts = item.opts.map((t,v)=>
        `<button class="opt" data-scale="unesp" data-key="${item.key}" data-val="${v}">
           <span class="opt-num">${v}</span>${t}
         </button>`).join('');
      wrap.innerHTML = `
        <div class="au-head">
          <span class="au-name">${item.name}</span>
          <span class="au-val" id="uval-${item.key}"></span>
        </div>
        ${help}
        <div class="au-opts four">${opts}</div>`;
      grid.appendChild(wrap);
    });
  });

  grid.querySelectorAll('.opt').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const key = btn.dataset.key;
      unespState[key] = Number(btn.dataset.val);
      root.querySelectorAll(`#unesp-grid .opt[data-key="${key}"]`).forEach(o=>o.classList.remove('sel'));
      btn.classList.add('sel');
      root.querySelector("#"+'uval-'+key).textContent = 'Score: '+btn.dataset.val;
      calcUNESP();
    });
  });
}

function calcUNESP(){
  let total=0, scored=0, abpSkipped=false;
  UNESP.forEach((block,bi)=>{
    let subSum=0;
    block.items.forEach(item=>{
      const v = unespState[item.key];
      if(v!==undefined){ subSum+=v; total+=v; scored++; }
      else if(item.key==='abp'){ abpSkipped=true; }
    });
    root.querySelector("#"+'sub-'+bi).textContent = `${subSum} / ${block.max}`;
  });

  const bar = root.querySelector("#"+'unesp-bar');
  const num = root.querySelector("#"+'unesp-num');
  const title = root.querySelector("#"+'unesp-title');
  const desc = root.querySelector("#"+'unesp-desc');

  if(scored===0){
    bar.style.background='var(--fps-line)';
    num.textContent='–'; num.style.background='var(--fps-line)'; num.style.color='var(--fps-muted)';
    title.textContent='No items scored';
    desc.textContent='Score the items above. The subscale subtotals, total and rescue-analgesia recommendation update automatically.';
    return;
  }

  const maxPossible = abpSkipped && unespState['abp']===undefined ? 27 : 30;
  const meets = total >= 8;
  const color = meets ? 'var(--fps-s4)' : (total>=4 ? 'var(--fps-s2)' : 'var(--fps-s0)');

  bar.style.background=color;
  num.style.background=color; num.style.color='#06121a';
  num.textContent = total;

  let note = (scored<UNESP.reduce((n,b)=>n+b.items.length,0))
      ? ` (${scored} of 10 items scored${abpSkipped && unespState['abp']===undefined ? ', blood pressure excluded' : ''})` : '';
  title.textContent = `UNESP-Botucatu total ${total} / ${maxPossible}${note}`;

  if(meets){
    desc.textContent = `At or above the rescue-analgesia cut-off (≥8/30). Rescue analgesia is recommended; treat and re-score after intervention. Final decision rests with the attending veterinarian.`;
  } else {
    desc.textContent = `Below the rescue-analgesia cut-off (≥8/30). Continue monitoring and re-score at regular intervals, particularly after any procedure or change in condition.`;
  }
}

function resetUNESP(){
  for(const k in unespState) delete unespState[k];
  root.querySelectorAll('#unesp-grid .opt').forEach(o=>o.classList.remove('sel'));
  root.querySelectorAll('#unesp-grid .au-val').forEach(v=>v.textContent='');
  UNESP.forEach((block,bi)=>{ root.querySelector("#"+'sub-'+bi).textContent = `0 / ${block.max}`; });
  calcUNESP();
  root.scrollIntoView({behavior:'smooth',block:'start'});
}

buildUNESP();

/* =================== GLASGOW CMPS-FELINE (0-20) =================== */
const GLASGOW = [
  {key:'g_vocal', name:'1. Vocalisation', note:'Observe the cat in its cage/kennel, undisturbed.',
   opts:['Silent / purring / meowing','Crying / growling / groaning']},
  {key:'g_posture', name:'2. Posture', note:'',
   opts:['Relaxed','Licking lips','Restless / cowering at back of cage','Tense / crouched','Rigid / hunched']},
  {key:'g_attention', name:'3. Attention to wound', note:'',
   opts:['Ignoring any wound or painful area','Attention to (looking at / licking) wound']},
  {key:'g_ears', name:'4a. Facial expression — ear position',
   help:'Original form uses caricature drawings. Match the closest.',
   opts:['Ears normal, facing forward','Ears partially flattened','Ears flattened and rotated outward / pinned back']},
  {key:'g_muzzle', name:'4b. Facial expression — muzzle shape',
   help:'Original form uses caricature drawings. Match the closest.',
   opts:['Muzzle relaxed (normal, rounded)','Muzzle mildly tense','Muzzle tense / tight (elliptical)']},
  {key:'g_stroke', name:'5. Response to stroking', note:'Approach and stroke the cat from head to tail.',
   opts:['Responds to stroking','Unresponsive','Aggressive']},
  {key:'g_pressure', name:'6. Response to pressure around the painful area',
   note:'Apply gentle pressure ~5 cm around the wound / surgical site.',
   opts:['Do nothing','Swish tail / flatten ears','Cry / hiss','Growl','Bite / lash out']},
  {key:'g_impression', name:'7. Overall demeanour / general impression', note:'',
   opts:['Happy and content','Disinterested / quiet','Anxious / fearful','Dull','Depressed / grumpy']}
];
const GLASGOW_MAX = 20;

const glasgowState = {};

function buildGlasgow(){
  const grid = root.querySelector("#"+'glasgow-grid');
  GLASGOW.forEach(item=>{
    const wrap = document.createElement('div');
    wrap.className='au';
    const note = item.note ? `<div class="au-help">${item.note}</div>` : '';
    const help = item.help ? `<div class="au-help"><b>Tip:</b> ${item.help}</div>` : '';
    const opts = item.opts.map((t,v)=>
      `<button class="opt" data-scale="glasgow" data-key="${item.key}" data-val="${v}">
         <span class="opt-num">${v}</span>${t}
       </button>`).join('');
    wrap.innerHTML = `
      <div class="au-head">
        <span class="au-name">${item.name}</span>
        <span class="au-val" id="gval-${item.key}"></span>
      </div>
      ${note}${help}
      <div class="au-opts flex">${opts}</div>`;
    grid.appendChild(wrap);
  });
  grid.querySelectorAll('.opt').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const key = btn.dataset.key;
      glasgowState[key] = Number(btn.dataset.val);
      root.querySelectorAll(`#glasgow-grid .opt[data-key="${key}"]`).forEach(o=>o.classList.remove('sel'));
      btn.classList.add('sel');
      root.querySelector("#"+'gval-'+key).textContent = 'Score: '+btn.dataset.val;
      calcGlasgow();
    });
  });
}

function calcGlasgow(){
  let total=0, answered=0;
  GLASGOW.forEach(item=>{
    const v = glasgowState[item.key];
    if(v!==undefined){ total+=v; answered++; }
  });
  const bar = root.querySelector("#"+'glasgow-bar');
  const num = root.querySelector("#"+'glasgow-num');
  const title = root.querySelector("#"+'glasgow-title');
  const desc = root.querySelector("#"+'glasgow-desc');

  if(answered===0){
    bar.style.background='var(--fps-line)';
    num.textContent='–'; num.style.background='var(--fps-line)'; num.style.color='var(--fps-muted)';
    title.textContent='No questions answered';
    desc.textContent='Answer the seven questions above. The total and intervention recommendation update automatically.';
    return;
  }

  const complete = answered===GLASGOW.length;
  const meets = total>=5;
  const color = meets ? 'var(--fps-s4)' : (total===4 ? 'var(--fps-s2)' : 'var(--fps-s0)');

  bar.style.background=color;
  num.style.background=color; num.style.color='#06121a';
  num.textContent = total;

  const note = complete ? '' : ` (score incomplete — some items not yet answered)`;
  title.textContent = `Glasgow CMPS-Feline total ${total} / ${GLASGOW_MAX}${note}`;

  if(meets){
    desc.textContent = `At or above the analgesic intervention level (≥5/20). Analgesia is indicated${complete?'':' even before completing the score'}; treat and re-score after intervention.`;
  } else if(total===4){
    desc.textContent = `Score ${total}/20 — just below the intervention level of ≥5/20. Watch closely and re-score shortly; low threshold to treat if the cat trends up or looks painful.`;
  } else {
    desc.textContent = `Below the analgesic intervention level (≥5/20). Continue monitoring and re-score at regular intervals, especially after any procedure or change in condition.`;
  }
}

function resetGlasgow(){
  for(const k in glasgowState) delete glasgowState[k];
  root.querySelectorAll('#glasgow-grid .opt').forEach(o=>o.classList.remove('sel'));
  root.querySelectorAll('#glasgow-grid .au-val').forEach(v=>v.textContent='');
  calcGlasgow();
  root.scrollIntoView({behavior:'smooth',block:'start'});
}

buildGlasgow();

/* Shopify/component wiring */
root.querySelectorAll("[data-fps-scale]").forEach(function(button){button.addEventListener("click",function(){switchScale(button.getAttribute("data-fps-scale"));});});
const r0=root.querySelector("[data-fps-reset-csu]"); if(r0) r0.addEventListener("click",resetTool);
const r1=root.querySelector("[data-fps-reset-fgs]"); if(r1) r1.addEventListener("click",resetFGS);
const r2=root.querySelector("[data-fps-reset-unesp]"); if(r2) r2.addEventListener("click",resetUNESP);
const r3=root.querySelector("[data-fps-reset-glasgow]"); if(r3) r3.addEventListener("click",resetGlasgow);
root.querySelectorAll("[data-fps-print]").forEach(function(button){button.addEventListener("click",function(){window.print();});});

}}if(!customElements.get("s-feline-pain-scale-calculator")){customElements.define("s-feline-pain-scale-calculator",FelinePainScaleCalculator);}})();
